import * as React from "react";
import { connect } from "react-redux";

import {
  EarnPoints as EarnPointsComponent,
  EarnPointsProps,
} from "../../components/EarnPoints/EarnPoints";

class EarnPoints extends React.Component<EarnPointsProps> {
  render() {
    return <EarnPointsComponent {...this.props} />;
  }
}

export default connect(null, {})(EarnPoints);
